import { Select, styled } from '@mui/material';
import React from 'react';

const StyledSelectSx = styled(Select)(({ theme }) => ({
  height: 40,
  borderRadius: '50vh',
  '&:hover': {
    '&& fieldset': {
      borderColor: 'rgba(102, 175, 233, 0.6)',
      boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6)',
    },
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 1,
    borderColor: 'rgba(102, 175, 233, 0.6)',
    boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6)',
  },
}),
);

export const StyledSelect = (props) => {
  return (
    <StyledSelectSx
      {...props}
      MenuProps={{
        sx: {
          gap: 1,
        },
        slotProps: {
          paper: {
            sx: {
              border: 1,
              borderColor: (theme) => theme.palette.inputFieldGlow.main,
              borderRadius: '4px',
            },
          },
        },
      }}
    />
  );
};
